<template>
  <div id="status" >
    <div style="width: 100%; height: 30px;" ></div>
    <div class="title" >请选择会员身份</div>
    <div style="width: 100%; height: 20px;" ></div>
    <div >
      <van-radio-group v-model="radio" class="radio-group" >
        <!--<van-radio
          v-for="(item, index) in list"
          :key="index"
          v-if="item.enable"
          class="radio"
          :name="index"
          :disabled="item.disabled">
          {{item.name}}</van-radio>-->
        <van-cell-group>
          <van-cell
            v-for="(item, index) in list"
            :key="index"
            :title="item.name"
            clickable
            v-if="item.enable">
            <van-radio :name="index" checked-color="#185494" />
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </div>
    <div class="footer" >
      <van-button
        class="submit-btn"
        size="large"
        @click="routerPush()"
        :class="{ active: radio==0 || radio==1 || radio==2 || radio==3 || radio==4 }">下一步</van-button>
      <!--<div class="router-go" @click="routerGo()" >返回</div>-->
    </div>
  </div>
</template>

<script>

import Vue from 'vue'
import _ from 'lodash'
import { RadioGroup, Radio, Button, Toast } from 'vant'
import { checkPassport } from '@/libs/passport'
import { getValidMembership } from '@/utils'
import { getMemberType, setMemberType, getMembership } from '@/libs/cookie-storage'

Vue.use(RadioGroup).use(Radio).use(Button)

export default {
  name: 'choice-of-status.vue',
  data () {
    return {
      list: [
        {id: 1, name: '运动员', type: 'player'},
        {id: 2, name: '教练员', type: 'coach'},
        {id: 3, name: '场内裁判员', type: 'in-referee'},
        {id: 4, name: '场外裁判员', type: 'out-referee'},
        {id: 0, name: '会员单位', type: 'member'}
      ],
      radio: -1,
      validMemberShip: null
    }
  },
  created() {
    checkPassport()
    this.validMemberShip = getValidMembership()
    const firstReg = this.validMemberShip.membership
    for (var i = 0; i < this.list.length; i++) {
      if (this.list[i].type === 'player') {
        this.list[i].enable = this.validMemberShip.playerRegisterEnabled
      } else if (this.list[i].type === 'coach') {
        this.list[i].enable = this.validMemberShip.coachRegisterEnabled
      } else if (this.list[i].type === 'in-referee') {
        this.list[i].enable = this.validMemberShip.inRefereeRegisterEnabled
      } else if (this.list[i].type === 'out-referee') {
        this.list[i].enable = this.validMemberShip.outRefereeRegisterEnabled
      } else if (this.list[i].type === 'member') {
        this.list[i].enable = this.validMemberShip.orgRegisterEnabled
      }
      const obj = _.find(firstReg, (item) => {
        return item.membershipTypeId === this.list[i].id
      })
      this.list[i].disabled = !_.isEmpty(obj)
    }
  },
  methods: {
    routerPush() {
      if (this.radio < 0) {
        Toast({
          duration: 1000,
          message: '请选择注册会员身份'
        })
        return
      }
      const member = this.list[this.radio]
      member.membershipTypeId = member.id
      setMemberType(member)
      if (member.id == 0 || member.id == 2) {
        this.$router.push({ path: 'info'})
      } else {
        this.$router.push({ path: 'identity-protocol', query: {id: 2} })
      }
    },
    routerGo() {},
    radioEvent() {
    }
  }
}
</script>

<style scoped>

  #status {
    height: 100%;
    background-color: white;
    padding: 0 15px;
    position: relative;
  }

  #status .title {
    font-size: 24px;
    text-align: center;
    font-weight:500;
    color:rgba(24,84,148,1);
  }

  #status .radio {
    font-size: 16px;
  }

  #status .radio i.van-icon {
    border: 1px solid red !important;
  }

  #status .radio-group {
  }

  #status .radio-group .radio {
    margin-bottom: 10px;
  }

  #status .router-go {
    display: block;
    text-align: center;
    padding-top: 4%;
    color: #7e8c8d;
    font-size: 16px; /*no*/
  }

  #status .footer {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }

  #status .van-cell-group:after {
    border-color: transparent;
  }

  #status .submit-btn {
    height:60px;
    background:rgba(245,245,245,1);
    border-radius:2px;
    border: none;
    margin-top: 30px;
    font-weight:400;
    color:rgba(129,129,129,1);
    font-size:20px;
  }

  #status .active {
    background: #185494;
    color: white;
  }

</style>



// WEBPACK FOOTER //
// src/pages/auth/choice-of-status.vue